var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeWidth: 11.887,
    d: "M38 43.943h6.576a4 4 0 0 1 4 4v47.114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeWidth: 11.887,
    d: "M71.19 53.943c0-5.522 4.477-10 10-10h4.962c5.523 0 10 4.478 10 10v.963c0 5.523-4.477 10-10 10h-4.963c-5.522 0-10-4.478-10-10v-.963Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeWidth: 11.887,
    d: "M65 83c0-6.627 5.373-12 12-12h13c6.627 0 12 5.373 12 12v0c0 6.627-5.373 12-12 12H77c-6.627 0-12-5.373-12-12v0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#d)",
    strokeWidth: 10.753,
    d: "M134.624 69.5c0 35.378-28.897 64.124-64.624 64.124S5.376 104.878 5.376 69.5 34.273 5.376 70 5.376s64.624 28.746 64.624 64.124Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.88,
    d: "M135.06 69.5c0 35.649-29.122 64.56-65.06 64.56S4.94 105.149 4.94 69.5 34.062 4.94 70 4.94s65.06 28.911 65.06 64.56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2.377,
    d: "M38 43.943h5.821a4.755 4.755 0 0 1 4.755 4.755v46.359M71.19 53.943c0-5.522 4.477-10 10-10h4.962c5.523 0 10 4.478 10 10v.963c0 5.523-4.477 10-10 10h-4.963c-5.522 0-10-4.478-10-10v-.963ZM65 83c0-6.627 5.373-12 12-12h13c6.627 0 12 5.373 12 12s-5.373 12-12 12H77c-6.627 0-12-5.373-12-12Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 78.228,
    x2: 34.705,
    y1: 112.906,
    y2: 117.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 166.139,
    x2: 83.448,
    y1: 77.623,
    y2: 119.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 205.737,
    x2: 104.382,
    y1: 104.075,
    y2: 177.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 112.083,
    x2: 18.884,
    y1: 50.47,
    y2: -99.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.fff43f09bc5e5ce0b41d284512193047.svg";
export { ForwardRef as ReactComponent };